<template>
	<div class="container">
		<div class="content-wrapper">
			<!-- 时间选择器 -->
			<div class="time-filter">
				<div v-for="(item, index) in timeTabs" :key="index" class="time-tab" @click="switchTime(item.value)">
					<div class="time-div-class">
						<div v-if="currentTime === item.value" class="active-time-div">{{ item.label }}</div>
						<div v-else class="time-div">{{ item.label }}</div>
						<div v-if="currentTime === item.value" class="time-div-line"></div>
					</div>
				</div>
				<div class="headr-setting">
					<img class="headr-setting-image" src="@/assets/images/report/1@2x(1).png" @click="settingAction()"/>
				
				</div>
			</div>

			<!-- 部门 -->
			<div class="dept-filter" style="width: 100%;" v-if="deptTabs&&deptTabs.length>1">
				<div v-for="(item, index) in deptTabs" :key="index" class="dept-tab" @click="switchDept(item)">
					<div class="dept-div-class">
						<div v-if="currentDept === item" class="active-dept-div">{{ item }}</div>
						<div v-else class="dept-div">{{ item }}</div>
					</div>
				</div>
			</div>

			<div class="report-content" v-if="mBusinessdata.length>0">
				<!-- 营业分析 -->
				<div class="business-analysis">
					<div class="business-analysis-title">
						<div>营业分析</div>
						<div class="business-analysis-title-time"
							style="width: auto;">{{mReportQuery.BeginDate+" - "+mReportQuery.EndDate}}</div>
						<div class="business-analysis-title-right" @click="switchCompare()">
							<div style="flex: 1;">{{switchCompareType==true?'去年同期':'上月同期'}}</div>
							<div style="margin-right: 16px;">></div>
						</div>
					</div>
				</div>

				<div class="business-analysis-money" v-if="mBusinessdata.length>0">
					<div class="business-analysis-money-title">
						<div class="div">{{mBusinessdata.length>=1?mBusinessdata[0].Name:''}}</div>
						<div class="div">{{mBusinessdata.length>=2?mBusinessdata[1].Name:''}}</div>
						<div class="div">{{mBusinessdata.length>=3?mBusinessdata[2].Name:''}}</div>
					</div>
					<div class="business-analysis-money-title">
						<div class="money">{{mBusinessdata.length>=1?mBusinessdata[0].Money:''}} <div
								:class="isRed(0,mBusinessdata)===1?'red':isRed(0,mBusinessdata)===0?'green':'transparent' ">{{mBusinessdata.length>=1?mBusinessdata[0].Amount_R:''}}</div></div>
						<div class="money">{{mBusinessdata.length>=2?mBusinessdata[1].Money:''}}<div
								:class="isRed(1,mBusinessdata)===1?'red':isRed(1,mBusinessdata)===0?'green':'transparent' ">{{mBusinessdata.length>=2?mBusinessdata[1].Amount_R:''}}</div></div>
						<div class="money">{{mBusinessdata.length>=3?mBusinessdata[2].Money:''}} <div
								:class="isRed(2,mBusinessdata)===1?'red':isRed(2,mBusinessdata)===0?'green':'transparent' ">{{mBusinessdata.length>=3?mBusinessdata[2].Amount_R:''}}</div></div>
					</div>
				</div>

				<div class="business-analysis-money" v-if="mBusinessdata.length>3">
					<div class="business-analysis-money-title">
						<div class="div">{{mBusinessdata.length>=4?mBusinessdata[3].Name:''}}</div>
						<div class="div">{{mBusinessdata.length>=5?mBusinessdata[4].Name:''}}</div>
						<div class="div">{{mBusinessdata.length>=6?mBusinessdata[5].Name:''}}</div>
					</div>
					<div class="business-analysis-money-title">
						<div class="money">{{mBusinessdata.length>=4?mBusinessdata[3].Money:''}}<div
								:class="isRed(3,mBusinessdata)===1?'red':isRed(3,mBusinessdata)===0?'green':'transparent' ">{{mBusinessdata.length>=4?mBusinessdata[3].Amount_R:''}}</div></div>
						<div class="money">{{mBusinessdata.length>=5?mBusinessdata[4].Money:''}}<div
								:class="isRed(4,mBusinessdata)===1?'red':isRed(4,mBusinessdata)===0?'green':'transparent' ">{{mBusinessdata.length>=5?mBusinessdata[4].Amount_R:''}}</div></div>
						<div class="money">{{mBusinessdata.length>=6?mBusinessdata[5].Money:''}}<div
								:class="isRed(5,mBusinessdata)===1?'red':isRed(5,mBusinessdata)===0?'green':'transparent' ">{{mBusinessdata.length>=6?mBusinessdata[5].Amount_R:''}}</div></div>
					</div>
				</div>
				
				<div class="business-analysis-money" v-if="mBusinessdata.length>6">
					<div class="business-analysis-money-title">
						<div class="div">{{mBusinessdata.length>=7?mBusinessdata[6].Name:''}}</div>
						<div class="div">{{''}}</div>
						<div class="div">{{''}}</div>
					</div>
					<div class="business-analysis-money-title">
						<div class="money">{{mBusinessdata.length>=7?mBusinessdata[6].Money:''}}<div
								:class="isRed(6,mBusinessdata)===1?'red':isRed(6,mBusinessdata)===0?'green':'transparent' ">{{mBusinessdata.length>=7?mBusinessdata[6].Amount_R:''}}</div></div>
						<div class="money">{{''}}<div :class="'transparent'">{{''}}</div></div>
						<div class="money">{{''}}<div :class="'transparent'">{{''}}</div></div>
					</div>
				</div>

				<!-- 客流 -->
				<div class="business-analysis">
					<div class="business-analysis-title">
						<div>客流</div>
						<div class="business-analysis-title-time"></div>
						<div class="business-analysis-title-retract" @click="cardStates.customer=!cardStates.customer">
							<div>收起</div>
							<img class="image"
								:src="cardStates.customer?'@/assets/images/report/1@2x(3).png':'@/assets/images/report/1@2x(15).png'"/>
						</div>
					</div>
				</div>

				<div class="business-analysis-money" v-if="cardStates.customer">
					<div class="business-analysis-money-title">
						<div class="div">{{mGuestdata.length>=1?mGuestdata[0].Name:''}}</div>
						<div class="div">{{mGuestdata.length>=2?mGuestdata[1].Name:''}}</div>
						<div class="div">{{mGuestdata.length>=3?mGuestdata[2].Name:''}}</div>
					</div>
					<div class="business-analysis-money-title" v-if="cardStates.customer">
						<div class="money">{{mGuestdata.length>=1?mGuestdata[0].Money:''}} <div
								:class="isRed(0,mGuestdata)===1?'red':isRed(0,mGuestdata)===0?'green':'transparent' ">{{mGuestdata.length>=1?mGuestdata[0].Amount_R:''}}</div></div>
						<div class="money">{{mGuestdata.length>=2?mGuestdata[1].Money:''}} <div
								:class="isRed(1,mGuestdata)===1?'red':isRed(1,mGuestdata)===0?'green':'transparent'">{{mGuestdata.length>=2?mGuestdata[1].Amount_R:''}}</div></div>
						<div class="money">{{mGuestdata.length>=3?mGuestdata[2].Money:''}} <div
								:class="isRed(2,mGuestdata)===1?'red':isRed(2,mGuestdata)===0?'green':'transparent'">{{mGuestdata.length>=2?mGuestdata[2].Amount_R:''}}</div></div>
					</div>
				</div>

				<div class="business-analysis-money" v-if="cardStates.customer&&mGuestdata.length>3">
					<div class="business-analysis-money-title">
						<div class="div">{{mGuestdata.length>=4?mGuestdata[3].Name:''}}</div>
						<div class="div">{{mGuestdata.length>=5?mGuestdata[4].Name:''}}</div>
						<div class="div">{{mGuestdata.length>=6?mGuestdata[5].Name:''}}</div>
					</div>
					<div class="business-analysis-money-title">
						<div class="money">{{mGuestdata.length>=4?mGuestdata[3].Money:''}} <div
								:class="isRed(3,mGuestdata)===1?'red':isRed(3,mGuestdata)===0?'green':'transparent'">{{mGuestdata.length>=4?mGuestdata[3].Amount_R:''}}</div></div>
						<div class="money">{{mGuestdata.length>=5?mGuestdata[4].Money:''}} <div
								:class="isRed(4,mGuestdata)===1?'red':isRed(4,mGuestdata)===0?'green':'transparent'">{{mGuestdata.length>=5?mGuestdata[4].Amount_R:''}}</div></div>
						<div class="money">{{mGuestdata.length>=6?mGuestdata[5].Money:''}} <div
								:class="isRed(5,mGuestdata)===1?'red':isRed(5,mGuestdata)===0?'green':'transparent'">{{mGuestdata.length>=6?mGuestdata[5].Amount_R:''}}</div></div>
					</div>
				</div>


				<div class="business-analysis-money" v-if="cardStates.customer&&mGuestdata.length>6">
					<div class="business-analysis-money-title">
						<div class="div">{{mGuestdata.length>=7?mGuestdata[6].Name:''}}</div>
						<div class="div">{{mGuestdata.length>=8?mGuestdata[7].Name:''}}</div>
						<div class="div"></div>
					</div>
					<div class="business-analysis-money-title">
						<div class="money">{{mGuestdata.length>=7?mGuestdata[6].Money:''}} <div
								:class="isRed(6,mGuestdata)===1?'red':isRed(6,mGuestdata)===0?'green':'transparent'">{{mGuestdata.length>=7?mGuestdata[6].Amount_R:''}}</div></div>
						<div class="money">{{mGuestdata.length>=8?mGuestdata[7].Money:''}}<div
								:class="isRed(7,mGuestdata)===1?'red':isRed(7,mGuestdata)===0?'green':'transparent'">{{mGuestdata.length>=8?mGuestdata[7].Amount_R:''}}</div></div>
						<div class="money"> <div class="red" style="background-color: transparent;"></div></div>
					</div>
				</div>

				<!-- 会员 -->
				<div class="business-analysis" >
					<div class="business-analysis-title">
						<div>会员</div>
						<div class="business-analysis-title-time"></div>
						<div class="business-analysis-title-retract" @click="cardStates.member=!cardStates.member">
							<div>收起</div>
							<img class="image"
								:src="cardStates.member?'@/assets/images/report/1@2x(3).png':'@/assets/images/report/1@2x(15).png'"/>
						</div>
					</div>
				</div>

				<div class="business-analysis-money" v-if="cardStates.member&&mMemberdata.length>0">
					<div class="business-analysis-money-title">
						<div class="div">{{mMemberdata.length>=1?mMemberdata[0].Name:''}}</div>
						<div class="div">{{mMemberdata.length>=2?mMemberdata[1].Name:''}}</div>
						<div class="div">{{mMemberdata.length>=3?mMemberdata[2].Name:''}}</div>
					</div>
					<div class="business-analysis-money-title">
						<div class="money">{{mMemberdata.length>=1?mMemberdata[0].Money:''}}<div
								:class="isRed(0,mMemberdata)===1?'red':isRed(0,mMemberdata)===0?'green':'transparent'">{{mMemberdata.length>=1?mMemberdata[0].Amount_R:''}}</div></div>
						<div class="money">{{mMemberdata.length>=2?mMemberdata[1].Money:''}} <div
								:class="isRed(1,mMemberdata)===1?'red':isRed(1,mMemberdata)===0?'green':'transparent' ">{{mMemberdata.length>=2?mMemberdata[1].Amount_R:''}}</div></div>
						<div class="money">{{mMemberdata.length>=3?mMemberdata[2].Money:''}} <div
								:class="isRed(2,mMemberdata)===1?'red':isRed(2,mMemberdata)===0?'green':'transparent'">{{mMemberdata.length>=3?mMemberdata[2].Amount_R:''}}</div></div>
					</div>
				</div>

				<div class="business-analysis-money" v-if="cardStates.member&&mMemberdata.length>3">
					<div class="business-analysis-money-title">
						<div class="div">{{mMemberdata.length>=4?mMemberdata[3].Name:''}}</div>
						<div class="div">{{mMemberdata.length>=5?mMemberdata[4].Name:''}}</div>
						<div class="div">{{mMemberdata.length>=6?mMemberdata[5].Name:''}}</div>
					</div>
					<div class="business-analysis-money-title">
						<div class="money">{{mMemberdata.length>=4?mMemberdata[3].Money:''}}<div
								:class="isRed(3,mMemberdata)===1?'red':isRed(3,mMemberdata)===0?'green':'transparent'">{{mMemberdata.length>=4?mMemberdata[3].Amount_R:''}}</div></div>
						<div class="money">{{mMemberdata.length>=5?mMemberdata[4].Money:''}} <div
								:class="isRed(4,mMemberdata)===1?'red':isRed(4,mMemberdata)===0?'green':'transparent' ">{{mMemberdata.length>=5?mMemberdata[4].Amount_R:''}}</div></div>
						<div class="money">{{mMemberdata.length>=6?mMemberdata[5].Money:''}}<div
								:class="isRed(5,mMemberdata)===1?'red':isRed(5,mMemberdata)===0?'green':'transparent'">{{mMemberdata.length>=6?mMemberdata[5].Amount_R:''}}</div></div>
					</div>
				</div>

				<div class="business-analysis-money" v-if="cardStates.member&&mMemberdata.length>6">
					<div class="business-analysis-money-title">
						<div class="div">{{mMemberdata.length>=7?mMemberdata[6].Name:''}}</div>
						<div class="div">{{mMemberdata.length>=8?mMemberdata[7].Name:''}}</div>
						<div class="div"></div>
					</div>
					<div class="business-analysis-money-title">
						<div class="money">{{mMemberdata.length>=7?mMemberdata[6].Money:''}} <div
								:class="isRed(6,mMemberdata)===1?'red':isRed(6,mMemberdata)===0?'green':'transparent'">{{mMemberdata.length>=7?mMemberdata[6].Amount_R:''}}</div></div>
						<div class="money">{{mMemberdata.length>=8?mMemberdata[7].Money:''}} <div
								:class="isRed(7,mMemberdata)===1?'red':isRed(7,mMemberdata)===0?'green':'transparent'">{{mMemberdata.length>=8?mMemberdata[7].Amount_R:''}}</div></div>
						<div class="money"> <div class="red" style="background-color: transparent;"></div></div>
					</div>
				</div>

				<!-- 按摩 -->
				<div class="business-analysis">
					<div class="business-analysis-title">
						<div>按摩</div>
						<div class="business-analysis-title-time"></div>
						<div class="business-analysis-title-retract" @click="cardStates.anMo=!cardStates.anMo">
							<div>收起</div>
							<img class="image"
								:src="cardStates.anMo?'@/assets/images/report/1@2x(3).png':'@/assets/images/report/1@2x(15).png'"/>
						</div>
					</div>
				</div>

				<div class="business-analysis-money" v-if="cardStates.anMo&&mAnModata.length>0">
					<div class="business-analysis-money-title">
						<div class="div">{{mAnModata.length>=1?mAnModata[0].Name:''}}</div>
						<div class="div">{{mAnModata.length>=2?mAnModata[1].Name:''}}</div>
						<div class="div">{{mAnModata.length>=3?mAnModata[2].Name:''}}</div>
					</div>
					<div class="business-analysis-money-title">
						<div class="money">{{mAnModata.length>=1?mAnModata[0].Money:''}}<div
								:class="isRed(0,mAnModata)===1?'red':isRed(0,mAnModata)===0?'green':'transparent'">{{mAnModata.length>=1?mAnModata[0].Amount_R:''}}</div></div>
						<div class="money">{{mAnModata.length>=2?mAnModata[1].Money:''}}<div
								:class="isRed(1,mAnModata)===1?'red':isRed(1,mAnModata)===0?'green':'transparent'">{{mAnModata.length>=2?mAnModata[1].Amount_R:''}}</div></div>
						<div class="money">{{mAnModata.length>=3?mAnModata[2].Money:''}} <div
								:class="isRed(2,mAnModata)===1?'red':isRed(2,mAnModata)===0?'green':'transparent'">{{mAnModata.length>=3?mAnModata[2].Amount_R:''}}</div></div>
					</div>
				</div>

				<div class="business-analysis-money" v-if="cardStates.anMo&&mAnModata.length>3">
					<div class="business-analysis-money-title">
						<div class="div">{{mAnModata.length>=4?mAnModata[3].Name:''}}</div>
						<div class="div"></div>
						<div class="div"></div>
					</div>
					<div class="business-analysis-money-title">
						<div class="money">{{mAnModata.length>=4?mAnModata[3].Money:''}}<div
								:class="isRed(3,mAnModata)===1?'red':isRed(3,mAnModata)===0?'green':'transparent'">{{mAnModata.length>=4?mAnModata[3].Amount_R:''}}</div></div>
						<div class="money"> <div class="red" style="background-color: transparent;"></div></div>
						<div class="money"> <div class="red" style="background-color: transparent;"></div></div>

					</div>
				</div>

				<!-- 餐饮 -->
				<div class="business-analysis" >
					<div class="business-analysis-title">
						<div>餐饮</div>
						<div class="business-analysis-title-time"></div>
						<div class="business-analysis-title-retract" @click="cardStates.food=!cardStates.food">
							<div>收起</div>
							<img class="image"
								:src="cardStates.food?'@/assets/images/report/1@2x(3).png':'@/assets/images/report/1@2x(15).png'"/>
						</div>
					</div>
				</div>

				<div class="business-analysis-money" v-if="cardStates.food&&mFoodata.length>1">
					<div class="business-analysis-money-title">
						<div class="div">{{mFoodata.length>=1?mFoodata[0].Name:''}}</div>
						<div class="div">{{mFoodata.length>=2?mFoodata[1].Name:''}}</div>
						<div class="div">{{mFoodata.length>=3?mFoodata[2].Name:''}}</div>
					</div>
					<div class="business-analysis-money-title">
						<div class="money">{{mFoodata.length>=1?mFoodata[0].Money:''}} <div
								:class="isRed(0,mFoodata)===1?'red':isRed(0,mFoodata)===0?'green':'transparent'">{{mFoodata.length>=1?mFoodata[0].Amount_R:''}}</div></div>
						<div class="money">{{mFoodata.length>=2?mFoodata[1].Money:''}}<div
								:class="isRed(1,mFoodata)===1?'red':isRed(1,mFoodata)===0?'green':'transparent' ">{{mFoodata.length>=2?mFoodata[1].Amount_R:''}}</div></div>
						<div class="money">{{mFoodata.length>=3?mFoodata[2].Money:''}}<div
								:class="isRed(2,mFoodata)===1?'red':isRed(2,mFoodata)===0?'green':'transparent'">{{mFoodata.length>=3?mFoodata[2].Amount_R:''}}</div></div>
					</div>
				</div>

				<div class="business-analysis-money" v-if="cardStates.food&&mFoodata.length>3">
					<div class="business-analysis-money-title">
						<div class="div">{{mFoodata.length>=4?mFoodata[3].Name:''}}</div>
						<div class="div">{{mFoodata.length>=5?mFoodata[4].Name:''}}</div>
						<div class="div"></div>
					</div>
					<div class="business-analysis-money-title">
						<div class="money">{{mFoodata.length>=4?mFoodata[3].Money:''}}<div
								:class="isRed(3,mFoodata)===1?'red':isRed(3,mFoodata)===0?'green':'transparent'">{{mFoodata.length>=4?mFoodata[3].Amount_R:''}}</div></div>
						<div class="money">{{mFoodata.length>=5?mFoodata[4].Money:''}}<div
								:class="isRed(4,mFoodata)===1?'red':isRed(4,mFoodata)===0?'green':'transparent'">{{mFoodata.length>=5?mFoodata[4].Amount_R:''}}</div></div>
						<div class="money"> <div class="red" style="background-color: transparent;"></div></div>

					</div>
				</div>

				<!-- 客房 -->
				<div class="business-analysis" >
					<div class="business-analysis-title">
						<div>客房</div>
						<div class="business-analysis-title-time"></div>
						<div class="business-analysis-title-retract" @click="cardStates.room=!cardStates.room">
							<div>收起</div>
							<img class="image"
								:src="cardStates.room?'@/assets/images/report/1@2x(3).png':'@/assets/images/report/1@2x(15).png'"/>
						</div>
					</div>
				</div>

				<div class="business-analysis-money" v-if="cardStates.room">
					<div class="business-analysis-money-title">
						<div class="div">{{mRoomdata.length>=1?mRoomdata[0].Name:''}}</div>
						<div class="div">{{mRoomdata.length>=2?mRoomdata[1].Name:''}}</div>
						<div class="div">{{mRoomdata.length>=3?mRoomdata[2].Name:''}}</div>
					</div>
					<div class="business-analysis-money-title">
						<div class="money">{{mRoomdata.length>=1?mRoomdata[0].Money:''}}<div
								:class="isRed(0,mRoomdata)===1?'red':isRed(0,mRoomdata)===0?'green':'transparent'">{{mRoomdata.length>=1?mRoomdata[0].Amount_R:''}}</div></div>
						<div class="money">{{mRoomdata.length>=2?mRoomdata[1].Money:''}}<div
								:class="isRed(1,mRoomdata)===1?'red':isRed(1,mRoomdata)===0?'green':'transparent' ">{{mRoomdata.length>=2?mRoomdata[1].Amount_R:''}}</div></div>
						<div class="money">{{mRoomdata.length>=3?mRoomdata[2].Money:''}}<div
								:class="isRed(2,mRoomdata)===1?'red':isRed(2,mRoomdata)===0?'green':'transparent' ">{{mRoomdata.length>=3?mRoomdata[2].Amount_R:''}}</div></div>
								
								
					</div>
				</div>

				<div class="business-analysis-money" v-if="cardStates.room">
					<div class="business-analysis-money-title">
						<div class="div">{{mRoomdata.length>=4?mRoomdata[3].Name:''}}</div>
						<div class="div">{{mRoomdata.length>=5?mRoomdata[4].Name:''}}</div>
						<div class="div">{{mRoomdata.length>=6?mRoomdata[5].Name:''}}</div>
					</div>
					<div class="business-analysis-money-title">
						<div class="money">{{mRoomdata.length>=4?mRoomdata[3].Money:''}}<div
								:class="isRed(3,mRoomdata)===1?'red':isRed(3,mRoomdata)===0?'green':'transparent'">{{mRoomdata.length>=4?mRoomdata[3].Amount_R:''}}</div></div>
						<div class="money">{{mRoomdata.length>=5?mRoomdata[4].Money:''}}<div
								:class="isRed(4,mRoomdata)===1?'red':isRed(4,mRoomdata)===0?'green':'transparent'">{{mRoomdata.length>=5?mRoomdata[4].Amount_R:''}}</div></div>
						<div class="money">{{mRoomdata.length>=6?mRoomdata[5].Money:''}}<div
								:class="isRed(5,mRoomdata)===1?'red':isRed(5,mRoomdata)===0?'green':'transparent'">{{mRoomdata.length>=6?mRoomdata[5].Amount_R:''}}</div></div>
					</div>
				</div>
				
				
				<div class="business-analysis-money" v-if="cardStates.room">
					<div class="business-analysis-money-title">
						<div class="div">{{mRoomdata.length>=7?mRoomdata[6].Name:''}}</div>
						<div class="div">{{mRoomdata.length>=8?mRoomdata[7].Name:''}}</div>
						<div class="div">{{mRoomdata.length>=9?mRoomdata[8].Name:''}}</div>
					</div>
					<div class="business-analysis-money-title">
						<div class="money">{{mRoomdata.length>=7?mRoomdata[6].Money:''}}<div
								:class="isRed(6,mRoomdata)===1?'red':isRed(6,mRoomdata)===0?'green':'transparent'">{{mRoomdata.length>=7?mRoomdata[6].Amount_R:''}}</div></div>
						<div class="money">{{mRoomdata.length>=8?mRoomdata[7].Money:''}}<div
								:class="isRed(7,mRoomdata)===1?'red':isRed(7,mRoomdata)===0?'green':'transparent'">{{mRoomdata.length>=8?mRoomdata[7].Amount_R:''}}</div></div>
						<div class="money">{{mRoomdata.length>=9?mRoomdata[8].Money:''}}<div
								:class="isRed(8,mRoomdata)===1?'red':isRed(8,mRoomdata)===0?'green':'transparent'">{{mRoomdata.length>=9?mRoomdata[8].Amount_R:''}}</div></div>
					</div>
				</div>

				<!-- 客源 -->
				<div class="business-analysis" v-if="showCharts&&mGuestPayData.series[0].data.length>0">
					<div class="business-analysis-title">
						<div style="flex: 1;text-align: left;">客源</div>
						<div class="guest-pay">
							<div :class="currentGuest==1?'guest-pay-action':'guest-pay-nomal'"
								@click="switchguestPayType(1)">线上线下</div>
							<div :class="currentGuest==2?'guest-pay-action':'guest-pay-nomal'"
								@click="switchguestPayType(2)">付款方式</div>
						</div>
						<div style="flex: 1;" />
					</div>
				</div>
				<div class="business-analysis-money" style="height: 500px;width: 100%;"
					v-if="showCharts&&mGuestPayData.series&&mGuestPayData.series[0].data.length>0">

					<div class="guestPay-div-class">
						<div class="ring-chart-container">
							<!-- 环形图 -->
							<div class="ring-chart-wrapper">
								<canvas ref="guestPayRing" id="guestPayRing" class="ring-canvas"
									:width="ringCanvasSize" :height="ringCanvasSize"
									:style="{ width: ringCanvasSize + 'px', height: ringCanvasSize + 'px' }"></canvas>
								<!-- 中心文字 -->
								<div class="ring-center-div">
									<div class="center-label">合计:</div>
									<div class="center-value">{{ringTotalMoney}}元</div>
								</div>
							</div>
							<!-- 右侧图例 -->
							<div class="ring-legend">
								<div class="legend-item" v-for="(item, index) in ringChartData" :key="index">
									<div class="legend-color" :style="{ backgroundColor: item.color }"></div>
									<div class="legend-div">{{item.name}}:{{item.percentage}}%</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- 销售排行 -->
				<div class="business-analysis">
					<div class="business-analysis-title">
						<div style="flex: 1;text-align: left;">销售排行</div>
						<div class="guest-pay">
							<div :class="currentSalesRanking==1?'guest-pay-action':'guest-pay-nomal'"
								@click="switchSalesType(1)">类别排行</div>
							<div :class="currentSalesRanking==2?'guest-pay-action':'guest-pay-nomal'"
								@click="switchSalesType(2)">菜品排行</div>
						</div>
						<div style="flex: 1;" />
					</div>
				</div>
				<div class="business-analysis-money" style="height: auto;width: 100%;" >
					<div class="sales-Rank-wrapper">
						<div class="sales-Rank-header" style="flex: 0.5;">排行</div>
						<div class="sales-Rank-header">类别</div>
						<div class="sales-Rank-header" style="display: flex;align-items: center;">
							<div style="flex: 1;"></div>
							<div style="width:auto;">营业额</div>
							<div class="sales-Rank-header-sort">
								<img class="sales-Rank-header-sort-image" src="@/assets/images/report/up.png" 
									@click="SortSaleData('OrigMoneyAsc')" />
								<img src="@/assets/images/report/down.png"  style="margin-top: 2px;"
									class="sales-Rank-header-sort-image" @click="SortSaleData('OrigMoneyDesc')" />
							</div>
							<div style="flex: 1;"></div>
						</div>
						<div class="sales-Rank-header" style="display: flex;align-items: center;">
							<div style="flex: 1;"></div>
							<div style="width:auto;">实收</div>
							<div class="sales-Rank-header-sort">
								<img class="sales-Rank-header-sort-image" src="@/assets/images/report/up.png"
									@click="SortSaleData('RealMoneyAsc')" />
								<img src="@/assets/images/report/down.png"  style="margin-top: 2px;"
									class="sales-Rank-header-sort-image" @click="SortSaleData('RealMoneyDesc')" />
							</div>
							<div style="flex: 1;"></div>
						</div>
						<div class="sales-Rank-header" style="display: flex;align-items: center;">
							<div style="flex: 1;"></div>
							<div style="width:auto;">占比</div>
							<div class="sales-Rank-header-sort">
								<img class="sales-Rank-header-sort-image" src="@/assets/images/report/up.png"
									@click="SortSaleData('PercentageAsc')" />
								<img src="@/assets/images/report/down.png"  style="margin-top: 2px;"
									class="sales-Rank-header-sort-image" @click="SortSaleData('PercentageDesc')" />
							</div>
							<div style="flex: 1;"></div>
						</div>
					</div>
					<div style="display: flex;flex-direction: column;">
						<div v-for="(item,index) in mSalesRankItems" :key="index">
							<div class="sales-Rank-wrapper" style="background-color: white;">
								<div class="sales-Rank-header" style="flex: 0.5;">{{index+1}}</div>
								<div
									class="sales-Rank-header">{{item.CatalogName?item.CatalogName:item.GoodsName}}</div>
								<div class="sales-Rank-header">{{updateMoney(item.OrigMoney)}}</div>
								<div class="sales-Rank-header">{{updateMoney(item.RealMoney)}}</div>
								<div class="sales-Rank-header">{{item.Percentage+'%'}}</div>
							</div>
						</div>
					</div>

				</div>

				<!-- 上钟分析 -->
				<div class="business-analysis" v-if="mClockChartData.series&&mClockChartData.series[0].data.length>0">
					<div class="business-analysis-title">
						<div style="flex: 1;text-align: left;">上钟分析</div>
					</div>
				</div>
				<div class="business-analysis-title" style="font-size: 14px;"
					v-if="mClockChartData.series&&mClockChartData.series[0].data.length>0">
					<div style="text-align: left;color: #39395C;">合计：</div>
					<div style="text-align: left;color: #595AEC;flex:1">{{mClockTotalData.ClockCount}}</div>
					<div style="text-align: left;color: #39395C;margin-left: 10px;">主项：</div>
					<div style="text-align: left;color: #595AEC;flex:1">{{mClockTotalData.MainCount}}</div>
					<div style="text-align: left;color: #39395C;margin-left: 10px;">小项：</div>
					<div style="text-align: left;color: #595AEC;flex:1">{{mClockTotalData.LittleCount}}</div>
				 </div>

                <div class="business-analysis-title" style="font-size: 14px;"
					v-if="mClockChartData.series&&mClockChartData.series[0].data.length>0">
					<div style="text-align: left;color: #39395C;">未结：</div>
					<div style="text-align: left;color: #595AEC;flex:1">{{mClockTotalData.NoCheckCount}}</div>
					<div style="text-align: left;color: #39395C;margin-left: 10px;">未结金额：</div>
					<div style="text-align: left;color: #595AEC;flex:1">{{mClockTotalData.OrigMoney}}</div>
					<div style="text-align: left;color: #fff;margin-left: 10px;">未结金额：</div>
					<div style="text-align: left;color: #595AEC;flex:1"></div>
				</div>

				<div  class ="upclock_view" >
					<div class="business-analysis-title"
						v-if="mClockChartData.series&&mClockChartData.series[0].data.length>0">
						
						<div class="guest-pay">
							<div v-for="(item,index) in mClockCategoriesItems" :key="index">
								<div v-if="currentUpClock===item" class="guest-pay-action"  
									@click="switchClickUpType(item)">{{item}}</div>
								<div v-else style="padding-left: 10px;padding-right: 10px;background-color: transparent;" class="guest-pay-nomal"
										@click="switchClickUpType(item)">{{item}}</div>
							</div>
						</div>
					</div>
				</div>
				
				<div class="business-analysis-money" style="height: 500px;width: 100%;"
					v-if="showCharts&&mClockChartData.series&&mClockChartData.series[0].data.length>0">
					<div class="ClockChart-div-class">
						<div class="ring-chart-container">
							<!-- 环形图 -->
							<div class="ring-chart-wrapper">
								<canvas ref="clockChartRing" id="clockChartRing" class="ring-canvas"
									:width="clockCanvasSize" :height="clockCanvasSize"
									:style="{ width: clockCanvasSize + 'px', height: clockCanvasSize + 'px' }"></canvas>
								<!-- 中心文字 -->
								<div class="ring-center-div">
									<div class="center-label">合计:</div>
									<div class="center-value">{{clockTotalCount}}个</div>
								</div>
							</div>
							<!-- 右侧图例 -->
							<div class="ring-legend">
								<div class="legend-item" v-for="(item, index) in clockChartData" :key="index">
									<div class="legend-color" :style="{ backgroundColor: item.color }"></div>
									<div class="legend-div">{{item.name}}:{{item.percentage}}%</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- 会员分析 -->
				<div class="business-analysis">
					<div class="business-analysis-title">
						<div>会员分析</div>
					</div>
				</div>

				<div class="business-analysis-title" style="font-size: 24px;">
					<div style="text-align: left;color: #39395C;font-size: 14px;">合计充值：</div>
					<div
						style="text-align: left;color: #595AEC;font-size: 14px">{{updateMoney((mMemberStatisticsNew.TotalMoney||0)+(mMemberStatisticsRechange.TotalMoney||0))}}</div>
					<div style="text-align: left;color: #39395C;font-size: 14px;">元</div>
					<div style="text-align: left;color: #39395C;margin-left: 30px;font-size: 14px;">合计消耗：</div>
					<div
						style="text-align: left;color: #595AEC;font-size: 14px;">{{updateMoney(mMemberStatisticsConsume.TotalMoney)}}</div>
					<div style="text-align: left;color: #595AEC;font-size: 14px;">元</div>
				</div>

				<div class="business-analysis-title" style="font-size: 14px;">
					<div style="text-align: left;font-size: 14px;">新签：</div>
					<div style="text-align: left;font-size: 14px;">{{updateMoney(mMemberStatisticsNew.TotalMoney)}}</div>
					<div style="text-align: left;font-size: 14px;">元</div>
				</div>

				<div class="business-analysis-money">
					<div class="business-analysis-money-title">
						<div class="div">办卡(张)</div>
						<div class="div">充值(元)</div>
						<div class="div">本金(元)</div>
						<div class="div">赠额(元)</div>
					</div>
					<div class="business-analysis-money-title">
						<div class="money">{{updateMoney(mMemberStatisticsNew.NumberCount)}}</div>
						<div class="money">{{updateMoney(mMemberStatisticsNew.TotalMoney)}}</div>
						<div class="money">{{updateMoney(mMemberStatisticsNew.RealMoney)}}</div>
						<div class="money">{{updateMoney(mMemberStatisticsNew.GiftMoney)}}</div>
					</div>
				</div>

				<div class="business-analysis-title" style="font-size: 24px;padding-top: 14px;">
					<div style="text-align: left;font-size: 14px;">续充：</div>
					<div style="text-align: left;font-size: 14px;">{{updateMoney(mMemberStatisticsRechange.TotalMoney)}}</div>
					<div style="text-align: left;font-size: 14px;">元</div>
				</div>

				<div class="business-analysis-money">
					<div class="business-analysis-money-title">
						<div class="div">续充(张)</div>
						<div class="div">充值(元)</div>
						<div class="div">本金(元)</div>
						<div class="div">赠额(元)</div>
					</div>
					<div class="business-analysis-money-title">
						<div class="money">{{updateMoney(mMemberStatisticsRechange.NumberCount)}}</div>
						<div class="money">{{updateMoney(mMemberStatisticsRechange.TotalMoney)}}</div>
						<div class="money">{{updateMoney(mMemberStatisticsRechange.RealMoney)}}</div>
						<div class="money">{{updateMoney(mMemberStatisticsRechange.GiftMoney)}}</div>
					</div>
				</div>

				<div class="business-analysis-title" style="font-size: 24px;padding-top: 14px;">
					<div style="text-align: left;font-size: 14px;">消耗：</div>
					<div style="text-align: left;font-size: 14px;">{{updateMoney(mMemberStatisticsConsume.TotalMoney)}}</div>
					<div style="text-align: left;font-size: 14px;">元</div>
				</div>

				<div class="business-analysis-money">
					<div class="business-analysis-money-title">
						<div class="div">本金(元)</div>
						<div class="div">赠额(元)</div>
						<div class="div">涨幅(%)</div>
						<div class="div">涨幅(元)</div>
					</div>
					<div class="business-analysis-money-title">
						<div class="money">{{updateMoney(mMemberStatisticsConsume.TotalMoney)}}</div>
						<div class="money">{{updateMoney(mMemberStatisticsConsume.GiftMoney)}}</div>
						<div class="money">{{updateMoney(mMemberStatisticsConsume.DiffRate)+'%'}}</div>
						<div class="money">{{updateMoney(mMemberStatisticsConsume.ReceiptConsumeDiff)}}</div>
					</div>
				</div>

			</div>

		</div>
		
		<van-calendar
  v-model="showCalendar"
  type="range"
  :min-date="dateMinDate"
  :max-date="dateMaxDate"
  :default-date="currentDate"
  :allow-same-day="true"
  color="#595AEC"
  @close="pickerClose"
  @confirm="maskClick"
/>
		<!-- 筛选弹窗 -->
		<filterPopupVue :visible="showFilterPopup" @update:visible="showFilterPopup = false"
			@confirm="handleFilterConfirm" @close="handleFilterConfirm" />
	</div>
</template>

<script>
	import filterPopupVue from './filter-popup/filter-popup.vue';
	import {
		DEPT_NAME,
		getdashboardSetting,
		TxtPadPosSwitchParlorcode,
		VPN_ID
	} from '@/api/login.js';
import { formatAmount } from '@/utils/format.js';
import { getdashboard } from '@/api/login.js';
import { handleLocalStorage } from '@/utils/index.js';
import { calculatePeriodDates,isNullOrEmpt,queryTime} from '@/utils/ToastUtils.js';

	export default {
		components: {
			filterPopupVue
		},
		data() {
			return {
				showCharts: true,
				showPicker: true,
				showCalendar:false,
				showFilterPopup: false,
				reportConfiData: [],
				dateRange: [],
				mBusinessdata: [],
				mGuestdata: [],
				mMemberdata: [],
				mAnModata: [],
				mFoodata: [],
				mRoomdata: [],
				mGuestPayData: {},
				mBusinessDataForDays: {},
				mPaymentStatisticsItems: [],
				mPaymentStatisticsItems2: [],
				mCatalogRankItems: [],
				mGoodsRankItems: [],
				mSalesRankItems: [],
				mClockCategoriesItems: [],
				mClockItems: {},
				mClockTotalData: {},
				mClockChartData: {},
				mMemberStatisticsNew: {},
				mMemberStatisticsRechange: {},
				mMemberStatisticsConsume: {},
				mMmberLine: {},
				mMmberLinedata: {},
				mMmberLinedata2: {},
				switchCompareType: false,
				// 环形图数据
				ringChartData: [],
				ringTotalMoney: '0',
				ringCanvasSize: 280,
				// 上钟环形图数据
				clockChartData: [],
				clockTotalCount: '0',
				clockCanvasSize: 280,
				// 时间筛选
				currentTime: 0,
				timeTabs: [{
						label: '今日',
						value: 0
					},
					{
						label: '昨日',
						value: 1
					},
					{
						label: '本月',
						value: 2
					},
					{
						label: '上月',
						value: 3
					},
					{
						label: '自定义',
						value: 4
					}
				],
				// 部门筛选
				currentDept: 'all',
				currentGuest: 1,
				currentSalesRanking: 1,
				currentUpClock: '',
				currentMemberType: 1,
				currentDate: [new Date(), new Date()],
                 dateMinDate: new Date(2020, 0, 1),
                 dateMaxDate: new Date(),
				 deptTabs: [],
				// 卡片收起状态
				cardStates: {
					customer: true,
					member: true,
					anMo: true,
					food: true,
					room: true
				},
				weekOpts: {
					color: ["#595AEC", "#91CB74", "#FAC858", "#EE6666", "#73C0DE", "#3CA272", "#FC8452", "#9A60B4",
						"#ea7ccc"
					],
					padding: [15, 15, 0, 15],
					enableScroll: true,
					dataLabel: false,
					legend: {},
					xAxis: {
						disableGrid: true,
						itemCount: 7,
					},
					yAxis: {
						gridType: "dash",
						dashLength: 1,
						//dashLength: 1
					},
					extra: {
						tooltip: {
							borderRadius: 4,
							boxPadding: 6,
							legendShow: false,
						},
						area: {
							type: "curve",
							opacity: 0.9,
							addLine: true,
							width: 2,
							gradient: true,
							activeType: "hollow"
						}
					}
				},
				UpClockOpts: {
					rotate: false,
					rotateLock: false,
					color: ["#595AEC", "#91CB74", "#FAC858", "#EE6666", "#73C0DE", "#3CA272", "#FC8452", "#9A60B4",
						"#ea7ccc"
					],
					padding: [5, 5, 5, 5],
					dataLabel: true,
					enableScroll: true,
					legend: {
						show: false,
						position: "right",
						lineHeight: 25
					},
					title: {
						name: "合计:",
						fontSize: 13,
						color: "#39395C"
					},
					subtitle: {
						name: "",
						fontSize: 13,
						color: "#39395C"
					},
					extra: {
						ring: {
							ringWidth: 30,
							activeOpacity: 0.5,
							activeRadius: 10,
							offsetAngle: 0,
							labelWidth: 15,
							border: true,
							borderWidth: 3,
							borderColor: "#FFFFFF"
						}
					}
				},
				guestPayOpts: {
					rotate: false,
					rotateLock: false,
					color: ["#595AEC", "#91CB74", "#FAC858", "#EE6666", "#73C0DE", "#3CA272", "#FC8452", "#9A60B4",
						"#ea7ccc"
					],
					padding: [5, 5, 5, 5],
					dataLabel: true,
					enableScroll: true,
					legend: {
						show: false,
						position: "right",
						lineHeight: 25
					},
					title: {
						name: "合计:",
						fontSize: 13,
						color: "#39395C"
					},
					subtitle: {
						name: "",
						fontSize: 13,
						color: "#39395C"
					},
					extra: {
						ring: {
							ringWidth: 30,
							activeOpacity: 0.5,
							activeRadius: 10,
							offsetAngle: 0,
							labelWidth: 15,
							border: true,
							borderWidth: 3,
							borderColor: "#FFFFFF"
						}
					}
				},
				lineOpts: {
					color: ["#1890FF", "#91CB74", "#FAC858", "#EE6666", "#73C0DE", "#3CA272", "#FC8452", "#9A60B4",
						"#ea7ccc"
					],
					padding: [15, 10, 0, 15],
					enableScroll: true,
					legend: {
						show: true,
						position: "bottom",
						lineHeight: 20
					},
					xAxis: {
						disableGrid: true,
						// scrollShow: true,
						itemCount: 4
					},
					yAxis: {
						gridType: "dash",
						dashLength: 2
					},
					extra: {
						line: {
							type: "straight",
							width: 2,
							activeType: "hollow"
						}
					}
				},
				mReportQuery: {
					VpnId: handleLocalStorage.get(VPN_ID),
					BeginDate: '',
					EndDate: '',
					CompareBegin: '',
					CompareEnd: '',
					IsRealTimeReport: true,
					Department: handleLocalStorage.get(DEPT_NAME),
					DepartmentName: handleLocalStorage.get(DEPT_NAME)
				}
			}
		},
		
		created() {
			this.queryvpn()
			this.dateRange.push(queryTime(0).substring(0, 10))
			this.dateRange.push(queryTime(0).substring(0, 10))
			this.mReportQuery.BeginDate = queryTime(0).substring(0, 10)
			this.mReportQuery.EndDate = queryTime(0).substring(0, 10)
			this.queryDeprt()
			this.handleFilterConfirm()

		},

		methods: {
	       queryvpn(){
            const vpnid = handleLocalStorage.get(VPN_ID)
			  if(isNullOrEmpt(vpnid)){
                  const vpnInfo = handleLocalStorage.get("vpnInfo");
				  handleLocalStorage.set(VPN_ID,vpnInfo.id)
			  }
		},
			//升序降序
			SortSaleData(type) {
				this.mSalesRankItems.sort((a, b) => {
					// 按id升序，可以改成其他属性如：a.age - b.age
					if (type == 'OrigMoneyAsc') {
						return a.OrigMoney - b.OrigMoney;
					} else if (type == 'OrigMoneyDesc') {
						return b.OrigMoney - a.OrigMoney;
					} else if (type == 'RealMoneyAsc') {
						return a.RealMoney - b.RealMoney;
					} else if (type == 'RealMoneyDesc') {
						return b.RealMoney - a.RealMoney;
					} else if (type == 'PercentageAsc') {
						return a.Percentage - b.Percentage;
					} else {
						return b.Percentage - a.Percentage;
					}
				});
			},
			parseMoneyValue(value) {
				if (value === undefined || value === null || value === '') return 0
				const money = Number(String(value).replace(/,/g, ''))
				return Number.isNaN(money) ? 0 : money
			},
			isMaxMoneyGreaterThanZero(list) {
				if (!(list instanceof Array) || list.length == 0) return false
				const maxMoney = Math.max(...list.map(item => this.parseMoneyValue(item && item.Money)))
				return maxMoney > 0
			},
			formatReportDate(date) {
				const year = date.getFullYear()
				const month = String(date.getMonth() + 1).padStart(2, '0')
				const day = String(date.getDate()).padStart(2, '0')
				return `${year}-${month}-${day}`
			},
			isValidReportDate(value) {
				if (!value || typeof value !== 'string') return false
				const datePart = value.split(' ')[0]
				const parts = datePart.split('-').map(item => Number(item))
				if (parts.length !== 3 || parts.some(item => Number.isNaN(item))) return false
				const date = new Date(parts[0], parts[1] - 1, parts[2])
				return date.getFullYear() === parts[0] &&
					date.getMonth() === parts[1] - 1 &&
					date.getDate() === parts[2]
			},
			getCurrentMonthRange() {
				const now = new Date()
				const year = now.getFullYear()
				const month = now.getMonth()
				return {
					begin: this.formatReportDate(new Date(year, month, 1)),
					end: this.formatReportDate(new Date(year, month + 1, 0))
				}
			},
			getLastMonthRange() {
				const now = new Date()
				const year = now.getFullYear()
				const month = now.getMonth()
				return {
					begin: this.formatReportDate(new Date(year, month - 1, 1)),
					end: this.formatReportDate(new Date(year, month, 0))
				}
			},
			repairReportDateRange() {
				if (this.isValidReportDate(this.mReportQuery.BeginDate) && this.isValidReportDate(this.mReportQuery.EndDate)) return
				if (this.currentTime == 2) {
					const range = this.getCurrentMonthRange()
					this.mReportQuery.BeginDate = range.begin
					this.mReportQuery.EndDate = range.end
				} else if (this.currentTime == 3) {
					const range = this.getLastMonthRange()
					this.mReportQuery.BeginDate = range.begin
					this.mReportQuery.EndDate = range.end
				}
			},

			pickerClose() {
				this.showCharts = true
				this.showFilterPopup = false
				this.showCalendar = false 
				this.queryDashboard()
			},
			maskClick(vale) {
				this.mReportQuery.IsRealTimeReport = false
				if (vale && vale instanceof Array && vale.length == 2) {
					this.mReportQuery.BeginDate = vale[0]
					this.mReportQuery.EndDate = vale[1]
				}
				this.showCalendar = false 
				this.showCharts = true
				this.showFilterPopup = false
				this.queryDashboard()
			},
			switchTime(value) {
				this.currentTime = value
				this.showCharts = true
				this.mReportQuery.IsRealTimeReport = false
				if (this.currentTime == 4) {
					this.showFilterPopup = false
					this.showCharts = false
					this.showCalendar = true
				} else {
					if (this.currentTime == 0) {
						this.mReportQuery.IsRealTimeReport = true
						this.mReportQuery.BeginDate = queryTime(0).substring(0, 10)
						this.mReportQuery.EndDate = queryTime(0).substring(0, 10)
					} else if (this.currentTime == 1) {
						this.mReportQuery.BeginDate = queryTime(-24).substring(0, 10)
						this.mReportQuery.EndDate = queryTime(-24).substring(0, 10)
					} else if (this.currentTime == 2) {
						const range = this.getCurrentMonthRange()
						this.mReportQuery.BeginDate = range.begin
						this.mReportQuery.EndDate = range.end
					} else if (this.currentTime == 3) {
						const range = this.getLastMonthRange()
						this.mReportQuery.BeginDate = range.begin
						this.mReportQuery.EndDate = range.end
					}
					this.queryDashboard()
				}
			},
			switchClickUpType(type) {

				console.log("switchClickUpType==== "+type)

				this.currentUpClock = type
				const childenArray = this.mClockItems[this.currentUpClock] || []
				this.mClockChartData = {
					series: [{
						data: []
					}]
				};
				let mTotalCount = 0
				const colors = ['#F5C469', '#595AEC', '#91CB74', '#FAC858', '#EE6666', '#73C0DE']
				
				// 准备上钟环形图数据
				this.clockChartData = []
				childenArray.forEach((mode, index) => {
					mTotalCount = mTotalCount + mode.ClockCount
					this.mClockChartData.series[0].data.push({
						name: mode.ClockType,
						value: mode.ClockCount,
						labelText: mode.ClockType + ':' + this.updateMoney(mode.Percentage) + "%"
					})
					// 添加到上钟环形图数据
					this.clockChartData.push({
						name: mode.ClockType,
						value: mode.ClockCount,
						percentage: this.updateMoney(mode.Percentage),
						color: colors[index % colors.length]
					})
				})
				this.UpClockOpts.subtitle.name = mTotalCount + '个'
				this.clockTotalCount = mTotalCount
				
				// 绘制上钟环形图
				this.$nextTick(() => {
					this.drawClockChart()
				})
			},
			switchMemberType(type) {
				this.currentMemberType = type
				this.mMmberLine ={}
				if (this.currentMemberType == 1) {
					this.mMmberLine =this.mMmberLinedata2
				} else {
					this.mMmberLine = this.mMmberLinedata
				}	
			},
			switchSalesType(type) {
				this.mSalesRankItems = []
				this.currentSalesRanking = type
				if (this.currentSalesRanking == 1) {
					this.mSalesRankItems.push(...this.mCatalogRankItems)
				} else {
					this.mSalesRankItems.push(...this.mGoodsRankItems)
				}
			},
			switchguestPayType(type) {
				this.currentGuest = type
				this.mGuestPayData = {}
				this.mGuestPayData = {
					series: [{
						data: []
					}]
				};
				const result = []
				let mTotalMoney = 0.0
				if (this.currentGuest == 1) {
					result.push(...this.mPaymentStatisticsItems2)
				} else {
					result.push(...this.mPaymentStatisticsItems)
				}

				result.forEach(mode => {
					mTotalMoney = mTotalMoney + mode.PayAmount
					this.mGuestPayData.series[0].data.push({
						name: mode.PayRemark,
						value: mode.PayAmount,
						labelText: mode.PayRemark + ':' + mode.Percentage + "%"
					})
				})
				this.guestPayOpts.subtitle.name = this.updateMoney(mTotalMoney) + '元'
				this.ringTotalMoney = this.updateMoney(mTotalMoney)
				
				// 准备环形图数据
				this.prepareRingChartData(result)
				
				// 绘制环形图
				this.$nextTick(() => {
					this.drawRingChart()
				})
			},
			// 准备环形图数据
			prepareRingChartData(result) {
				const colors = ['#F5C469', '#595AEC', '#91CB74', '#FAC858', '#EE6666', '#73C0DE']
				this.ringChartData = result.map((item, index) => ({
					name: item.PayRemark,
					value: item.PayAmount,
					percentage: item.Percentage,
					color: colors[index % colors.length]
				}))
			},
			// 绘制环形图
			drawRingChart() {
				const canvas = this.$refs.guestPayRing
				if (!canvas) return
				const ctx = canvas.getContext("2d")
				if (!ctx) return
				
				const size = this.ringCanvasSize
				const centerX = size / 2
				const centerY = size / 2
				const outerRadius = size * 0.38
				const innerRadius = size * 0.28
				
				// 清空画布
				ctx.clearRect(0, 0, size, size)
				
				// 计算总值
				const total = this.ringChartData.reduce((sum, item) => sum + item.value, 0)
				if (total === 0) return
				
				// 绘制环形图
				let startAngle = -Math.PI / 2
				
				this.ringChartData.forEach((item, index) => {
					const percentage = item.value / total
					const endAngle = startAngle + (percentage * Math.PI * 2)
					
					// 绘制扇形
					ctx.beginPath()
					ctx.arc(centerX, centerY, outerRadius, startAngle, endAngle, false)
					ctx.arc(centerX, centerY, innerRadius, endAngle, startAngle, true)
					ctx.closePath()
					ctx.fillStyle = item.color
					ctx.fill()
					
					// 绘制白色间隔
					ctx.beginPath()
					ctx.arc(centerX, centerY, outerRadius, endAngle - 0.02, endAngle + 0.02, false)
					ctx.arc(centerX, centerY, innerRadius, endAngle + 0.02, endAngle - 0.02, true)
					ctx.closePath()
					ctx.fillStyle = '#FFFFFF'
					ctx.fill()
					
					startAngle = endAngle
				})
			},
			// 绘制上钟环形图
			drawClockChart() {
				const canvas = this.$refs.clockChartRing
				if (!canvas) return
				const ctx = canvas.getContext("2d")
				if (!ctx) return
				
				const size = this.clockCanvasSize
				const centerX = size / 2
				const centerY = size / 2
				const outerRadius = size * 0.38
				const innerRadius = size * 0.28
				
				// 清空画布
				ctx.clearRect(0, 0, size, size)
				
				// 计算总值
				const total = this.clockChartData.reduce((sum, item) => sum + item.value, 0)
				if (total === 0) return
				
				// 绘制环形图
				let startAngle = -Math.PI / 2
				
				this.clockChartData.forEach((item, index) => {
					const percentage = item.value / total
					const endAngle = startAngle + (percentage * Math.PI * 2)
					
					// 绘制扇形
					ctx.beginPath()
					ctx.arc(centerX, centerY, outerRadius, startAngle, endAngle, false)
					ctx.arc(centerX, centerY, innerRadius, endAngle, startAngle, true)
					ctx.closePath()
					ctx.fillStyle = item.color
					ctx.fill()
					
					// 绘制白色间隔
					ctx.beginPath()
					ctx.arc(centerX, centerY, outerRadius, endAngle - 0.02, endAngle + 0.02, false)
					ctx.arc(centerX, centerY, innerRadius, endAngle + 0.02, endAngle - 0.02, true)
					ctx.closePath()
					ctx.fillStyle = '#FFFFFF'
					ctx.fill()
					
					startAngle = endAngle
				})
			},
			switchDept(name) {
				this.currentDept = name
				this.queryDashboard()
			},
			switchCompare() {
				this.switchCompareType = !this.switchCompareType
				this.queryDashboard()
			},
			/**查询报表数据*/
			async queryDashboard() {
				this.mReportQuery.VpnId = handleLocalStorage.get(VPN_ID)
				this.mReportQuery.DepartmentName = this.currentDept == "全部" ? null : this.currentDept
				this.mReportQuery.Department = this.mReportQuery.DepartmentName
				this.repairReportDateRange()
				const mBeginDate = this.mReportQuery.BeginDate
				const mEndDate = this.mReportQuery.EndDate
				const result = calculatePeriodDates(mBeginDate,mEndDate)
				if (this.switchCompareType) {
					this.mReportQuery.CompareBegin =result.lastYearPeriod.startDate
					this.mReportQuery.CompareEnd = result.lastYearPeriod.endDate
				} else {
					this.mReportQuery.CompareBegin =result.lastMonthPeriod.startDate
					this.mReportQuery.CompareEnd = result.lastMonthPeriod.endDate
				}
				getdashboard(this.mReportQuery).then(resp => {
					this.mBusinessdata = []
					this.mGuestdata = []
					this.mMemberdata = []
					this.mAnModata = []
					this.mFoodata = []
					this.mRoomdata = []
					this.mBusinessDataForDays = {}
					this.mGuestPayData = {}
					this.mCatalogRankItems = []
					this.mGoodsRankItems = []
					this.mClockCategoriesItems = []
					this.mClockItems = {}
					this.$nextTick(() => {
						this.queryBusinessData(resp)
						this.queryGuestdata(resp)
						this.queryMemberdata(resp)
						this.queryAnModata(resp)
						this.queryFoodata(resp)
						this.queryRoomdata(resp)
						this.queryBusinessDataForDays(resp)
						this.queryGuestPayData(resp)
						this.querySalesRankingData(resp)
						this.queryClockUpData(resp)
						this.querymMemberStatisticsItems(resp)
						this.queryMomberMoreLinedata(resp)
					})
				}).catch(error => {
					console.log("error ==== " + error)
					this.$toast(""+error);
				})
			},
			//充值消耗 新签充值
			queryMomberMoreLinedata(resp) {
				this.mMmberLinedata = {
					categories: [],
					series: []
				};

				this.mMmberLinedata2 = {
					categories: [],
					series: []
				};

				this.reportConfiData.forEach((mode, index) => {
					
					if (mode.Id == 'MmberRechangeConsume') {
						const categories = Object.keys(resp.MemberStatisticsItemsDic);
						categories.forEach(key => {
							const seriesItem = {
								name: key,
								data: []
							}
							const group = resp.MemberStatisticsItemsDic[key]
							group.forEach(item => {
								seriesItem.data.push(item.TotalMoney)
								const mBusinessDate = item.BusinessDate.substring(0, 10) + ''
								const mDay = mBusinessDate.split("-")
								if (this.mMmberLinedata.categories.includes(mDay[2]) == false) {
									this.mMmberLinedata.categories.push(mDay[2])
								}
							})
							this.mMmberLinedata.series.push(seriesItem)
						})
					}
					if (mode.Id == 'MmberNewAddRechange') {
						const categories = Object.keys(resp.MemberStatisticsItemsDic2);
						categories.forEach(key => {
							const seriesItem = {
								name: key,
								data: []
							}
							const group = resp.MemberStatisticsItemsDic2[key]
							group.forEach(item => {
								seriesItem.data.push(item.NumberCount)
								const mBusinessDate = item.BusinessDate.substring(0, 10) + ''
								const mDay = mBusinessDate.split("-")
								if (this.mMmberLinedata2.categories.includes(mDay[2]) == false) {
									this.mMmberLinedata2.categories.push(mDay[2])
								}
							})
							this.mMmberLinedata2.series.push(seriesItem)
						})
					}
				})
				this.switchMemberType(this.currentMemberType)
			},
			//会员分析
			querymMemberStatisticsItems(resp) {
				this.mMemberStatisticsNew = {}
				this.mMemberStatisticsRechange = {}
				this.mMemberStatisticsConsume = {}
				this.reportConfiData.forEach((mode, index) => {
					if (mode.Id == 'New') {
						(resp.MemberStatisticsItems2 || []).forEach(item => {
							if ((item.Type + "") == '新办') {
								this.mMemberStatisticsNew = item
							}
						})
					}
					if (mode.Id == 'ReChange') {
						(resp.MemberStatisticsItems2 || []).forEach(item => {
							if ((item.Type + "") == '续充') {
								this.mMemberStatisticsRechange = item
							}
						})
					}
					if (mode.Id == 'Consume') {
						(resp.MemberStatisticsItems2 || []).forEach(item => {
							if ((item.Type + "") == '消费') {
								this.mMemberStatisticsConsume = item
							}
						})
					}
				})

			},

			//上钟分析
			queryClockUpData(resp) {
				this.reportConfiData.forEach((mode, index) => {
					if (mode.Id == 'ClockStatisticsDic') {
						const categories = Object.keys(resp.ClockStatisticsDic);
						categories.forEach(name => {
							if (name != '合计') {
								this.mClockCategoriesItems.push(name)
							}
						})
						this.mClockItems = resp.ClockStatisticsDic
						if (this.mClockCategoriesItems.length == 0) {
							this.mClockCategoriesItems.push("足疗")
							this.mClockCategoriesItems.push("SPA")
							this.mClockCategoriesItems.push("搓澡")
						}
						this.currentUpClock = this.mClockCategoriesItems[0]
					}
				})
				const categories = Object.keys(resp.ClockStatisticsDic);
				if (categories.includes('合计')) {
					const totalList = this.mClockItems['合计']
					if (totalList instanceof Array) {
						totalList.forEach(mode => {
							this.mClockTotalData = mode
						})
					}
				}
				this.switchClickUpType(this.currentUpClock)
			},
			//销售排行
			querySalesRankingData(resp) {
				this.reportConfiData.forEach((mode, index) => {
					if (mode.Id == 'CatalogRankItems') {
						this.mCatalogRankItems.push(...resp.CatalogRankItems || [])
					}
					if (mode.Id == 'GoodsRankItems') {
						this.mGoodsRankItems.push(...resp.GoodsRankItems || [])
					}
				})
				this.switchSalesType(this.currentSalesRanking)
			},
			//客源（支付方式）
			queryGuestPayData(resp) {
				this.mPaymentStatisticsItems = []
				this.mPaymentStatisticsItems2 = []
				this.reportConfiData.forEach((mode, index) => {
					if (mode.Id == 'PaymentStatisticsItems') {
						this.mPaymentStatisticsItems.push(...resp.PaymentStatisticsItems || [])
					}
					if (mode.Id == 'PaymentStatisticsItems2') {
						this.mPaymentStatisticsItems2.push(...resp.PaymentStatisticsItems2 || [])
					}
				})
				this.switchguestPayType(this.currentGuest)
			},
			//近七日营业额
			queryBusinessDataForDays(resp) {
				this.mBusinessDataForDays = {
					categories: [],
					series: [{
						name: "近七日营业额",
						data: []
					}]
				};
				this.reportConfiData.forEach((mode, index) => {
					if (mode.Id == 'BusinessDataForDays') {
						(resp.BusinessDataForDays || []).forEach(item => {
							if (this.mBusinessDataForDays.categories.length < 7) {
								const mBusinessDate = item.BusinessDate.substring(0, 10) + ''
								const mDay = mBusinessDate.split("-")
								this.mBusinessDataForDays.categories.push(mDay[2])
								this.mBusinessDataForDays.series[0].data.push(item.BusinessAmount)
							}
						})
					}
				})
				this.weekOpts.xAxis.itemCount = this.mBusinessDataForDays.categories.length
			},



			//客房数据
			queryRoomdata(resp) {
				this.reportConfiData.forEach((mode, index) => {
					if (mode.Id == 'Room_Count') {
						this.mRoomdata.push({
							Money: this.updateMoney(resp.Room_Count),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Room_Count_R || 0))
						})
					}
					if (mode.Id == 'Room_TotalAmount') {
						this.mRoomdata.push({
							Money: this.updateMoney(resp.Room_TotalAmount),
							Name: mode.name,
							Amount_R: this.updatePercentage(resp.Room_TotalAmount_R || 0)
						})
					}
					if (mode.Id == 'Room_PersonRate') {
						this.mRoomdata.push({
							Money: this.updateMoney(resp.Room_PersonRate),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Room_PersonRate_R || 0))
						})
					}
					if (mode.Id == 'Room_PerIncome') {
						this.mRoomdata.push({
							Money: this.updateMoney(resp.Room_PerIncome),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Room_PerIncome_R || 0))
						})
					}
					if (mode.Id == 'Room_PerDayPrice') {
						this.mRoomdata.push({
							Money: this.updateMoney(resp.Room_PerDayPrice),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Room_PerDayPrice_R || 0))
						})
					}
					
					if (mode.Id == 'Room_LiveRate') {
						this.mRoomdata.push({
							Money: this.updateMoney(resp.Room_LiveRate),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Room_LiveRate_R || 0))
						})
					}
					
					if (mode.Id == 'Room_BookCount') {
						this.mRoomdata.push({
							Money: this.updateMoney(resp.Room_BookCount),
							Name: mode.name,
							Amount_R: ""
						})
					}
					
					if (mode.Id == 'Room_CheckInCount') {
						this.mRoomdata.push({
							Money: this.updateMoney(resp.Room_CheckInCount),
							Name: mode.name,
							Amount_R: ""
						})
					}
					
					if (mode.Id == 'Room_StayingCount') {
						this.mRoomdata.push({
							Money: this.updateMoney(resp.Room_StayingCount),
							Name: mode.name,
							Amount_R: ""
						})
					}
					
				})
			},


			//餐饮数据
			queryFoodata(resp) {
				this.reportConfiData.forEach((mode, index) => {
					if (mode.Id == 'Meal_PersonCount') {
						this.mFoodata.push({
							Money: this.updateMoney(resp.Meal_PersonCount),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Meal_PersonCount_R || 0))
						})
					}
					if (mode.Id == 'Meal_TotalAmount') {
						this.mFoodata.push({
							Money: this.updateMoney(resp.Meal_TotalAmount),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Meal_TotalAmount_R || 0))
						})
					}
					if (mode.Id == 'Meal_PerConsumeAmount') {
						this.mFoodata.push({
							Money: this.updateMoney(resp.Meal_PerConsumeAmount),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Meal_PerConsumeAmount_R || 0))
						})
					}
					if (mode.Id == 'Meal_PersonRate') {
						this.mFoodata.push({
							Money: this.updateMoney(resp.Meal_PersonRate),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Meal_PersonRate_R || 0))
						})
					}
					if (mode.Id == 'Meal_TableTurnoverRate') {
						this.mFoodata.push({
							Money: this.updateMoney(resp.Meal_TableTurnoverRate),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Meal_TableTurnoverRate_R || 0))
						})
					}

				})
			},
			//按摩数据
			queryAnModata(resp) {
				this.reportConfiData.forEach((mode, index) => {
					if (mode.Id == 'Clk_TotalClockCount') {
						this.mAnModata.push({
							Money: this.updateMoney(resp.Clk_TotalClockCount),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Clk_TotalClockCount_R || 0))
						})
					}
					if (mode.Id == 'Clk_AddClockCount') {
						this.mAnModata.push({
							Money: this.updateMoney(resp.Clk_AddClockCount),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Clk_AddClockCount_R || 0))
						})
					}
					if (mode.Id == 'Clk_TotalAmount') {
						this.mAnModata.push({
							Money: this.updateMoney(resp.Clk_TotalAmount),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Clk_TotalAmount_R || 0))
						})
					}
					if (mode.Id == 'Clk_PersonCount') {
						this.mAnModata.push({
							Money: this.updateMoney(resp.Clk_PersonCount),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Clk_PersonCount_R || 0))
						})
					}

				})
			},

			//会员数据
			queryMemberdata(resp) {
				this.reportConfiData.forEach((mode, index) => {
					if (mode.Id == 'Mem_NewcardNum') {
						this.mMemberdata.push({
							Money: this.updateMoney(resp.Mem_NewcardNum),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Mem_NewcardNum_R || 0))
						})
					}
					if (mode.Id == 'Mem_Receipt') {
						this.mMemberdata.push({
							Money: this.updateMoney(resp.Mem_Receipt),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Mem_Receipt_R || 0))
						})
					}
					if (mode.Id == 'Mem_Consume') {
						this.mMemberdata.push({
							Money: this.updateMoney(resp.Mem_Consume),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Mem_Consume_R || 0))
						})
					}
					if (mode.Id == 'Mem_ReceiptConsumeDiff') {
						this.mMemberdata.push({
							Money: this.updateMoney(resp.Mem_ReceiptConsumeDiff),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Mem_ReceiptConsumeDiff_R || 0))
						})
					}
					if (mode.Id == 'Mem_RechargeAmount') {

						this.mMemberdata.push({
							Money: this.updateMoney(resp.Mem_RechargeAmount),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Mem_RechargeAmount_R || 0))
						})
					}
					if (mode.Id == 'Mem_RechargeReceipt') {
						this.mMemberdata.push({
							Money: this.updateMoney(resp.Mem_RechargeReceipt),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Mem_RechargeReceipt_R || 0))
						})
					}
					if (mode.Id == 'Mem_RechargeGift') {
						this.mMemberdata.push({
							Money: this.updateMoney(resp.Mem_RechargeGift),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Mem_RechargeGift_R || 0))
						})
					}
					if (mode.Id == 'Mem_RenewalAmount') {
						this.mMemberdata.push({
							Money: this.updateMoney(resp.Mem_RenewalAmount),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Mem_RenewalAmount_R || 0))
						})
					}
				})
			},
			//客流数据
			queryGuestdata(resp) {
				this.mGuestdata = []
				this.reportConfiData.forEach((mode, index) => {

					if (mode.Id == 'Cus_PresentNum') {
						this.mGuestdata.push({
							Money: this.updateMoney(resp.Cus_PresentNum),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Cus_PresentNum_R || 0))
						})
					}
					if (mode.Id == 'Cus_EnterNum') {
						this.mGuestdata.push({
							Money: this.updateMoney(resp.Cus_EnterNum),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Cus_EnterNum_R || 0))
						})
					}
					if (mode.Id == 'Cus_LeaveNum') {
						this.mGuestdata.push({
							Money: this.updateMoney(resp.Cus_LeaveNum),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Cus_LeaveNum_R || 0))
						})
					}
					if (mode.Id == 'Cus_TotalNum') {
						this.mGuestdata.push({
							Money: this.updateMoney(resp.Cus_TotalNum),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Cus_TotalNum_R || 0))
						})
					}
					if (mode.Id == 'Cus_ReserveNum') {

						this.mGuestdata.push({
							Money: this.updateMoney(resp.Cus_ReserveNum),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Cus_ReserveNum_R || 0))
						})
					}
					if (mode.Id == 'Cus_ManNum') {
						this.mGuestdata.push({
							Money: this.updateMoney(resp.Cus_ManNum),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Cus_ManNum_R || 0))
						})
					}
					if (mode.Id == 'Cus_WomanNum') {
						this.mGuestdata.push({
							Money: this.updateMoney(resp.Cus_WomanNum),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Cus_WomanNum_R || 0))
						})
					}
					if (mode.Id == 'Cus_ChildrenNum') {
						this.mGuestdata.push({
							Money: this.updateMoney(resp.Cus_ChildrenNum),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.Cus_ChildrenNum_R || 0))
						})
					}
				})
			},
			/**营业数据**/
			queryBusinessData(resp) {
				this.reportConfiData.forEach((mode, index) => {
					if (mode.Id == 'BusinessAmount') {
						this.mBusinessdata.push({
							Money: this.updateMoney(resp.BusinessAmount),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.BusinessAmount_R || 0))
						})
					}
					if (mode.Id == 'SettledAmount') {
						this.mBusinessdata.push({
							Money: this.updateMoney(resp.SettledAmount),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.SettledAmount_R || 0))
						})
					}
					if (mode.Id == 'UnSettleAmount') {
						this.mBusinessdata.push({
							Money: this.updateMoney(resp.UnSettleAmount),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.UnSettleAmount_R || 0))
						})
					}
					if (mode.Id == 'PersonAvgAmount') {

						this.mBusinessdata.push({
							Money: this.updateMoney(resp.PersonAvgAmount),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.PersonAvgAmount_R || 0))
						})
					}
					if (mode.Id == 'OnlinePayAmount') {
						this.mBusinessdata.push({
							Money: this.updateMoney(resp.OnlinePayAmount),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.OnlinePayAmount_R || 0))
						})
					}
					if (mode.Id == 'OfllinePayAmount') {
						this.mBusinessdata.push({
							Money: this.updateMoney(resp.OfllinePayAmount),
							Name: mode.name,
							Amount_R: this.updatePercentage((resp.OfllinePayAmount_R || 0))
						})
					}
					if (mode.Id == 'CashFlow') {
						this.mBusinessdata.push({
							Money: this.updateMoney(resp.CashFlow),
							Name: mode.name,
							Amount_R: ""
						})
					}
				})
			},

			isRed(index, array) {
				if (array.length > index) {
					if (array[index].Amount_R.includes('↑')) {
						return 0 //涨
					} else if (array[index].Amount_R.includes('↓')) {
						return 1 //涨
					} else {
						return 2 //无
					}
				} else {
					return 2 //无
				}
			},
			updateMoney(money) {
				if ((money + '').includes('.')) {
					return formatAmount(money, 2, '')
				} else {
					return formatAmount(money, 0, '')
				}
			},
			updatePercentage(Percentage) {
				if (Percentage == 0.0) {
					return ""
				} else if (Percentage > 0.0) {
					return "↑ " + Percentage + '%'
				} else {
					return "↓ " + (Percentage) + '%'
				}
			},

			/**报表设置*/
			settingAction() {
				this.showCharts = false
				this.showFilterPopup = true
			},
			/**报表设置*/
			async handleFilterConfirm() {
				this.showCharts = true
				this.reportConfiData = []
				let mReportConfi = []
				const jsonString =handleLocalStorage.get('ReportConfi');
				if (isNullOrEmpt(jsonString)) {
					mReportConfi.push(...getdashboardSetting())
				} else {
					mReportConfi = JSON.parse(jsonString)
				}
				mReportConfi.filter((mode, index) => {
					mode.childen.filter((item, j) => {
						if (item.seleted) {
							this.reportConfiData.push(item)
						}
					})
				})
				this.queryDashboard()
			},
			/*查询部门*/
			queryDeprt() {
				this.deptTabs.push('全部')
				const list = handleLocalStorage.get(TxtPadPosSwitchParlorcode)
				if(list!==null){
                  this.deptTabs.push(...list)
				}
				if (this.deptTabs.length > 0) {
					this.currentDept = this.deptTabs[0]
				}
			},
		},
	}
</script>

<style scoped lang="scss">
	.container {
		width: 100%;
		height: 100vh;
		display: flex;
		flex-direction: column;
	}

	/* 内容区域 */
	.content-wrapper {
		
		// height: calc(100vh - env(safe-area-inset-bottom));
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.time-filter {
		height: 80px;
		width: 100%;
		border-top: 1px solid #F2F2F2;
		align-items: center;
		display: flex;
		text-align: center;

		.headr-setting {
			width: 100px;
			height: 78px;
			background: #FFFFFF;
			align-items: center;
			box-shadow: -4px 0px 4px 0px rgba(0, 0, 0, 0.06);

			.headr-setting-image {
				margin-top: 23px;
				width: 40px;
				height: 40px;
				object-fit: cover;
			}
		}
	}

	.time-tab {
		flex: 1;
		padding-left: 16px;
		padding-right: 16px;
		height: 100%;
		background-color: white;
	}

	.time-div-class {
		flex: 1;
		height: 80px;
		display: flex;
		flex-direction: column;
	}

	.time-div {
		width: 100%;
		height: 70px;
		line-height: 70px;
		font-size: 26px;
		color: #595AEC;
	}

	.active-time-div {
		width: 100%;
		font-size: 28px;
		font-weight: bold;
		line-height: 70px;
		color: #595AEC;
	}

	.time-div-line {
		width: 60%;
		margin-left: 20%;
		background-color: #595AEC;
		height: 5px;
		border-radius: 5px;
	}

	.dept-filter {
		width: auto;
		height: 48px;
		margin-top: 24px;
		border-top: 1px solid #F2F2F2;
		align-items: center;
		display: flex;
		text-align: center;
	}

	.dept-tab {
		flex: 1;
		padding-left: 16px;
		padding-right: 16px;
		height: 100%;
		background-color: white;
	}

	.dept-div-class {
		flex: 1;
		height: 48px;
		display: flex;
		flex-direction: column;
	}

	.dept-div {
		width: 100%;
		height: 48px;
		line-height: 48px;
		font-size: 24px;
		color: #595AEC;
	}

	.active-dept-div {
		width: 100%;
		font-size: 24px;
		height: 48px;
		line-height: 48px;
		color: white;
		background: linear-gradient(46deg, #595AEC 0%, #AAABFF 100%);
		border-radius: 30px;
	}

	.report-content {
		width: 96%;
		margin-left: 2%;
		margin-top: 24px;
		background: #FFFFFF;
		box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.04);
		border-radius: 16px;
		background-color: white;
		height: 100%;
		overflow-y: auto;
       overflow-x: hidden;
       -webkit-overflow-scrolling: touch;
	}

	.business-analysis {
		width: 100%;
		margin-top: 24px;
		height: auto;
		color: #595AEC;
		font-size: 28px;
		text-align: center;
		display: flex;
	}

	.business-analysis-title {
		align-items: center;
		width: 100%;
		height: 48px;
		line-height: 48px;
		margin-left: 16px;
		color: #595AEC;
		font-size: 28px;
		text-align: center;
		display: flex;

		.guest-pay {
			display: flex;
			text-align: center;
			width: auto;
			min-width: 400px;
			height: 48px;
			line-height: 48px;
			background: #EDEDFD;
			color: #595AEC;
			font-size: 24px;
			box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.04);
			border-radius: 30px;

			.guest-pay-action {
				width: auto;
				min-width: 160px;
				text-align: center;
				padding-left: 20px;
				padding-right: 20px;
				height: 48px;
				color: white;
				line-height: 48px;
				background: linear-gradient(46deg, #595AEC 0%, #AAABFF 100%);
				box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.04);
				border-radius: 30px;
			}

			.guest-pay-nomal {
				width: auto;
				min-width: 160px;
				padding-left: 20px;
				padding-right: 20px;
				text-align: center;
				height: 48px;
				color: #595AEC;
				line-height: 48px;
			}
		}
	}

	.business-analysis-title-time {
		flex: 1;
		line-height: 48px;
		margin-left: 16px;
		margin-left: 20px;
		font-size: 24px;
		color: #39395C;
		text-align: left;
	}

	.business-analysis-title-right {
		width: 150px;
		display: flex;
		margin-right: 16px;
		height: 48px;
		color: #595AEC;
		font-size: 24px;
		margin-left: 0px;
		background: rgba(89, 90, 236, 0.08);
		border-radius: 36px;
	}

	.business-analysis-title-retract {
		width: auto;
		display: flex;
		margin-right: 16px;
		height: 48px;
		color: #876FFF;
		font-size: 24px;
		margin-left: 20px;
		align-items: center;
		background: transparent;
		border-radius: 36px;

		.image {
			height: 28px;
			width: 28px;
			object-fit: contain;
		}

		.ring {
			width: 12px;
			height: 12px;
			background-color: #595AEC;
			border-radius: 12px;
		}
	}

	.business-analysis-money {
		width: 100%;
		height: 120px;
		display: flex;
		flex-direction: column;
		background: #FFFFFF;
		box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.04), 0px 4px 6px 6px rgba(0, 0, 0, 0.04);
		border-radius: 8px;
		margin-top: 24px;
		border-right: 1px solid #F2F2F2;

		.sales-Rank-wrapper {
			width: 96%;
			margin-left: 2%;
			display: flex;
			background-color: #F5F5FE;
			border-radius: 8px 8px 0px 0px;

			.sales-Rank-header {
				text-align: center;
				font-size: 24px;
				height: 40px;
				flex: 1;
				line-height: 40px;
				color: #39395C;
				border-right: 1px solid rgba(186, 186, 186, 0.4);
				border-bottom: 1px solid rgba(186, 186, 186, 0.4);
			}

			.sales-Rank-header-sort {
				display: flex;
				flex-direction: column;
				width: 15px;
				height: 30px;
				margin-left: 10px;

				.sales-Rank-header-sort-image {
					width: 100%;
					height: 15px;
					object-fit: contain
				}
			}


		}


	}

	.business-analysis-money-title {
		width: 100%;
		display: flex;
		align-items: center;
		height: 24px;
		margin-top: 24px;
		font-weight: normal;
		font-size: 24px;
		color: #303541;
		line-height: 24px;
		div-shadow: 0px 4px 6px rgba(0, 0, 0, 0.04);
		text-align: left;
		font-style: normal;
		div-transform: none;

		.div {
			margin-left: 16px;
			flex: 1;
			// font-size: 14px;
		}

		.money {
			margin-left: 16px;
			flex: 1;
			font-size: 32px;
			color: #39395C;

			.red {
				width: 80px;
				height: 32px;
				font-size: 20px;
				background: #FFEAEE;
				color: #FF2D55;
				padding-left: 20px;
				padding-right: 20px;
				box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.04);
				border-radius: 24px;
			}

			.green {
				width: 80px;
				height: 32px;
				padding-left: 20px;
				padding-right: 20px;
				font-size: 20px;
				color: #00C17C;
				background: #E5F8F1;
				box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.04);
				border-radius: 24px;
			}

			.transparent {
				width: 80px;
				height: 32px;
				padding-left: 20px;
				padding-right: 20px;
				font-size: 20px;
				color: transparent;
				background: transparent;
				box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.04);
				border-radius: 24px;
			}
		}
	}

	// 环形图样式
	.guestPay-div-class {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.ring-chart-container {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
		padding: 20px;
	}

	.ring-chart-wrapper {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.ring-canvas {
		display: block;
	}

	.ring-center-div {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.center-label {
		font-size: 28px;
		color: #666666;
		margin-bottom: 8px;
	}

	.center-value {
		font-size: 32px;
		color: #333333;
		font-weight: 500;
	}

	.ring-legend {
		display: flex;
		flex-direction: column;
		margin-left: 40px;
		justify-content: center;
		gap: 20px;
	}

	.legend-item {
		display: flex;
		align-items: center;
	}

	.legend-color {
		width: 20px;
		height: 20px;
		border-radius: 50%;
		margin-right: 16px;
	}

	.legend-div {
		font-size: 26px;
		color: #333333;
	}

	/* 上钟环形图样式 */
	.ClockChart-div-class {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.upclock_view{
		min-width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
	}
	/* 连接线样式通过Canvas绘制 */
</style>
